import { API_ROOT } from '../const'

export const VOUCHER_API = {
  fetch: (voucherCode, email, captchaToken) =>
    fetch(`${API_ROOT}/vouchers`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ voucherCode, email, captchaToken }),
    }).then((response) => {
      if (response.status >= 400) {
        throw new Error(response.status)
      }
      return response.json()
    }),
  post: (voucherRefundRequest) =>
    fetch(`${API_ROOT}/voucherRefund`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(voucherRefundRequest),
    }).then((response) => {
      if (response.status >= 400) {
        throw new Error(response.status)
      }
      return response.text()
    }),
}
